import { useState } from "react";
import { useNavigate } from "react-router-dom";
import VerifyPaystackPayment from "../VerifyPaystackPayment";
import { useCart } from "../../context/CartContext";

export default function PaymentCallback() {
  const { clearCart } = useCart();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <VerifyPaystackPayment
        onSuccess={(order) => {
          clearCart();
          setStatus("success");

          setTimeout(() => {
            navigate(`/order-success/${order._id}`);
          }, 1500);
        }}
        onError={(msg) => {
          setStatus("failed");
          setTimeout(() => navigate("/"), 2000);
        }}
      />

      {status === "verifying" && <p>Verifying payment...</p>}
      {status === "success" && <p>Payment successful 🎉</p>}
      {status === "failed" && <p>Payment verification failed</p>}
    </div>
  );
}
